











import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import Dots from "@/components/Dots.vue";

@Component({
  components: {
    Dots,
  },
})
export default class Aside extends Vue {
  @Prop() text?: string;
}
